export default function parseDictionary({
    enumNames,
    enumValues,
}: {
    enumNames: string[];
    enumValues: Array<string | number | null>;
}) {
    const filteredEnumValues = enumValues.filter((value) => value !== null) as string[];

    const result: { [key: string]: string } = {};

    filteredEnumValues.forEach((value, index) => {
        result[value] = enumNames[index];
    });

    return result;
}
